<div class="wizard-message box center margin-top-16" *ngIf="verified && message">
  <div [innerHTML]="message"></div>
</div>

<div class="wizard-inner-container">
  <div class="wizard-registration-title text-light">{{(partner && partner.RequiresPasswordReset ?
    'onboarding.titles.account_verification' : 'onboarding.titles.login') | translate}}</div>
  <div class="existing-user-message text-light"
       *ngIf="partner && !partner.RequiresPasswordReset ">{{'onboarding.existing_user' | translate}}</div>
  <div class="wizard-form">
    <div *ngIf="loading" class="wizard-loading">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                         animationDuration=".5s">
      </p-progressSpinner>
      <div>{{ 'onboarding.messages.verifying_account' | translate}}</div>
    </div>

    <form [formGroup]="VerificationForm" (ngSubmit)="setPassword()"
          *ngIf="verified && partner.RequiresPasswordReset">
      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <input class="sign-up-input"  type="password" formControlName="Password" autocomplete='false' placeholder="{{ 'onboarding.set_password' | translate}}"
                   (blur)="showPasswordStrength=false" (focus)="showPasswordStrength=true"/>
<!--            <label for="Password">{{ 'onboarding.set_password' | translate}}</label>-->
          </div>
        </div>
      </div>
      <app-password-strength *ngIf="showPasswordStrength" [score]="checkStrength(VerificationForm)">
      </app-password-strength>
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="input-group">
            <input class="sign-up-input"  type="password" formControlName="ConfirmPassword" id="ConfirmPassword" placeholder="{{ 'onboarding.confirm_password' | translate}}"
                   autocomplete='false'/>
<!--            <label for="ConfirmPassword">{{ 'onboarding.confirm_password' | translate}}</label>-->
          </div>
          <div class="invalid-text"
               *ngIf="VerificationForm.value.ConfirmPassword && VerificationForm.value.Password && VerificationForm.value.ConfirmPassword !== VerificationForm.value.Password">
            Passwords do not match
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button type="submit" class="iso-round-button iso-secondary w-100 mt-2"
                  [disabled]="!VerificationForm.valid  || saving">{{saving ? ('onboarding.button.please_wait' |
            translate) : ('onboarding.button.next' | translate)}}</button>

          <!--          //todo (dcorbett) removed || completed-->

        </div>
      </div>
    </form>

    <form [formGroup]="VerificationForm" (ngSubmit)="Authenticate()"
          *ngIf="verified && !partner.RequiresPasswordReset">
      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <input class="sign-up-input" type="text" [(ngModel)]="partner.Email" disabled
                   placeholder="{{ 'general.email' | translate}}"
                   [ngModelOptions]="{standalone: true}"
                   autocomplete='false'/>
<!--            <label for="Email">{{ 'general.email' | translate}}</label>-->
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <div class="input-group">
            <input class="sign-up-input" type="password" formControlName="Password" autocomplete='false' placeholder="{{ 'general.password' | translate}}"/>
<!--            <label for="Password">{{ 'general.password' | translate}}</label>-->
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <button type="submit" class="iso-round-button iso-secondary w-100 mb-2"
                  [disabled]="!VerificationForm.valid || saving">{{saving ? ('onboarding.button.please_wait' |
            translate) : ('onboarding.button.next' | translate)}}</button>

          <!--                  todo(dcorbett) removed || completed-->

        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button class="iso-round-button iso-secondary-outline w-100"
                  (click)="changeToResetPassword()">{{'onboarding.button.reset_password' | translate}}</button>
        </div>
      </div>
    </form>

    <div class="wizard-message fail center margin-top-32" *ngIf="(!verified && message)">
      <div [innerHTML]="message"></div>
    </div>
    <div class="wizard-message fail center margin-top-32" *ngIf="(!passwordSet && passwordMessage)">
      <div [innerHTML]="passwordMessage"></div>
    </div>
  </div>
</div>
